import { useState } from "react";

const Form = ({  isSubmitted, handleInputChange, handleFormSubmit }) => {
    const [errors, setErrors] = useState({
        cardName: '',
        cardNumber: '',
        mm: '',
        yy: '',
        cvc: ''
    });

    // inputs
    const handleInput = (e) => {
        const { name, value } = e.target;
        handleInputChange(e);
        

        
        const validations = {
            cardName: {
                required: true,
                regex: /^[a-z]+\s[a-z]+$/i,
                errorMessage: 'Enter a valid first and last name (e.g. Jane Applegate)',
            },
            cardNumber: {
                required: true,
                regex: /^(\d{4}\s)(\d{4}\s)(\d{4}\s)(\d{4})$/,
                errorMessage: 'Enter a valid 16 digit number format (e.g. 1234 5678 9000 0000)'
            },
            mm: {
                required: true,
                regex: /^(0[1-9]|1[0-2])$/,
                errorMessage: 'Enter a valid month (01-12)'
            },
            yy: {
                required: true,
                regex: /^\d{2}$/,
                errorMessage: 'Enter a valid year (e.g., 23)'
            },
            cvc: {
                required: true,
                regex: /^\d{3}$/,
                errorMessage: 'Enter a valid 3-digit CVC'
            }
        };

        const { required, regex, errorMessage } = validations[name] || {};

        let error = '';
        if (required && value.trim() === '') {
            error = 'Cant be blank';
        } else if (regex && !regex.test(value)) {
            error = errorMessage;
        }

        setErrors(prevErrors => ({ ...prevErrors, [name]: error }));
        
    }

    // submit 
    const handleSubmit = (e) => {
        e.preventDefault();
        
        
        
        // If no errors, submit the form
        handleFormSubmit();
    }
    
    return ( 
        <form onSubmit={handleSubmit} action="/" className="success-animation ">
            <div className="field">
                <label htmlFor="card-name">
                    <span>CARDHOLDER NAME</span>
                    <input onInput={handleInput} required className={errors['cardName'] ? 'invalid' : 'valid'} type="text" id="card-name" placeholder="e.g. Jane Appleseed " name="cardName" />
                    <span className="error" aria-live="polite">{errors['cardName']}</span>
                </label>
            </div>
            <div className="field">
                <label htmlFor="card-number">
                    <span>CARD NUMBER</span>
                    <input onInput={handleInput} required className={errors['cardNumber'] ? 'invalid' : 'valid'} type="text" id="card-number" placeholder="e.g. 1234 5678 9123 0000" name="cardNumber" />
                    <span className="error" aria-live="polite">{errors['cardNumber']}</span>
                </label>
            </div>
            <div className="field">
                <div className="date">
                    <div className="exp">
                        EXP. DATE [MM/YY]
                        <label className="date-input">
                            <div>
                                <input onInput={handleInput} required className={errors['mm'] ? 'invalid' : 'valid'} type="number" id="mm" placeholder="mm" name="mm" />
                                <span className="error">{errors['mm']}</span>
                            </div>
                            <div>
                                <input onInput={handleInput} required className={errors['yy'] ? 'invalid' : 'valid'} type="number" id="yy" placeholder="yy" name="yy" />
                                <span className="error">{errors['yy']}</span>
                            </div>
                        </label>
                        
                    </div>
                    <div className="exp-date">
                        <label htmlFor="cvc">
                            CVC
                            <input onInput={handleInput} required className={errors['cvc'] ? 'invalid' : 'valid'} type="number" id="cvc" placeholder="e.g. 123" name="cvc" />
                        </label>
                        <span className="error">{errors['cvc']}</span>
                    </div>
                </div>
            </div>
            <button id="submit">Confirm</button>
        </form>
     );
}
 
export default Form;